import PromotionCardsContainer from './PromotionCardsContainer';

export default PromotionCardsContainer;
